webpackJsonp([142629428675168],{

/***/ 864:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"en","langs":["en","ru"]}}}},"pathContext":{"slug":"/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-1f75a8fde90ddc3b461b.js